


//=============================

// import axios from 'axios';

// const api = axios.create({
//     baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:1338/api/',
//     timeout: 60000,
//     withCredentials: true,
// });

// // TEMPORARY — add at top of request interceptor, remove after fixing
// console.table(
//     Array.from({ length: localStorage.length }, (_, i) => ({
//         key: localStorage.key(i),
//         value: localStorage.getItem(localStorage.key(i))?.slice(0, 60)
//     }))
// );
// console.log("Cookies:", document.cookie);

// // ── Token extraction utility ──────────────────────────────────────────────
// const extractToken = () => {
//     // 1. Cookie — shared across all localhost ports
//     const getCookie = (name) => {
//         const value = `; ${document.cookie}`;
//         const parts = value.split(`; ${name}=`);
//         if (parts.length === 2) return parts.pop().split(";").shift();
//         return null;
//     };
//     const cookieToken = getCookie("auth_token");
//     if (cookieToken) return cookieToken;

//     // 2. Direct localStorage key — set by useAuth.js at login
//     const directToken = localStorage.getItem("auth_token");
//     if (directToken) return directToken;

//     // 3. Nested Redux-persisted format — localStorage["admin"]
//     //    Structure: { auth: '{"session":{"token":"eyJ..."},"user":{...}}' }
//     try {
//         const raw = localStorage.getItem("admin");
//         if (raw) {
//             const outer = JSON.parse(raw);
//             const authStr = outer?.auth;
//             if (authStr) {
//                 const auth = typeof authStr === "string"
//                     ? JSON.parse(authStr)
//                     : authStr;
//                 const token = auth?.session?.token;
//                 if (token) return token;
//             }
//         }
//     } catch (e) {
//         console.warn("[extractToken] Failed to parse admin key:", e.message);
//     }

//     console.error("[extractToken] No token found. Please log in on the main app first.");
//     return null;
// };

// // ── Request Interceptor ───────────────────────────────────────────────────
// api.interceptors.request.use(
//     (config) => {                          // ← removed async, not needed
//         const token = extractToken();

//         if (token) {
//             config.headers.Authorization = token.startsWith('Bearer ')
//                 ? token
//                 : `Bearer ${token}`;
//         } else {
//             // Token missing — warn early so you catch it in console
//             console.warn(`[API] No token found for request: ${config.method?.toUpperCase()} ${config.url}`);
//         }

//         return config;
//     },
//     (error) => Promise.reject(error)
// );

// // ── Response Interceptor ──────────────────────────────────────────────────
// api.interceptors.response.use(
//     (response) => response.data,  // unwrap data — your existing behaviour
//     (error) => {
//         const status = error.response?.status;
//         const url = error.config?.url || '';

//         if (status === 401) {
//             const isPinRoute =
//                 url.includes('/pin') ||
//                 url.includes('/unpin') ||
//                 url.includes('/pinned-messages');

//             if (isPinRoute) {
//                 // ── Pin routes failing 401 ─────────────────────────────
//                 // Don't log out — token may be valid but middleware has
//                 // a bug. Log clearly so backend dev can fix.
//                 console.error(
//                     `[API] 401 on pin route: ${url}\n` +
//                     `Token sent: ${error.config?.headers?.Authorization}\n` +
//                     `This is a backend verifyAccessToken issue — ` +
//                     `check middleware is reading Authorization header correctly.`
//                 );
//             } else {
//                 // ── Other 401s ─────────────────────────────────────────
//                 console.warn('[API] Unauthorized on:', url);
//                 // Uncomment when ready for production logout:
//                 // localStorage.removeItem('auth_token');
//                 // window.location.href = '/login';
//             }
//         }

//         return Promise.reject(error);
//     }
// );

// export default api;

//================================
//================================

import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:1338/api/',
});

// ── Token extraction — checks all possible locations in priority order ────────
const extractToken = () => {
    // PRIORITY 1: Cookie — set by backend at login with domain:"localhost"
    // Automatically shared across ALL localhost ports (:3000, :5555, etc.)
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
    };
    const cookieToken = getCookie("auth_token");
    if (cookieToken) return cookieToken;

    // PRIORITY 2: Own localStorage["auth_token"]
    // Set when: (a) main app saves it after login, or
    //           (b) chat app receives it via URL params from main app
    const localToken = localStorage.getItem("auth_token");
    if (localToken) return localToken;

    // PRIORITY 3: Legacy Redux-persist nested format
    // localStorage["admin"] → { auth: '{"session":{"token":"eyJ..."}}' }
    // Only works if both apps are on the same origin (rare in dev)
    try {
        const raw = localStorage.getItem("admin");
        if (raw) {
            const outer = JSON.parse(raw);
            const authStr = outer?.auth;
            if (authStr) {
                const auth = typeof authStr === "string" ? JSON.parse(authStr) : authStr;
                const token = auth?.session?.token;
                if (token) {
                    // Cache it so we don't parse every request
                    localStorage.setItem("auth_token", token);
                    return token;
                }
            }
        }
    } catch (e) {
        console.warn("[extractToken] Legacy parse failed:", e.message);
    }

    console.error(
        "[extractToken] No token found anywhere.\n" +
        "Fix: Open chat app from main app (localhost:5555) so token is passed in URL.\n" +
        "Or ensure you logged in recently (backend sets cookie with domain:localhost)."
    );
    return null;
};

// ── Request interceptor — attach token to every outgoing request ──────────────
api.interceptors.request.use(
    (config) => {
        const token = extractToken();

        if (token) {
            config.headers.Authorization = token.startsWith("Bearer ")
                ? token
                : `Bearer ${token}`;
        } else {
            console.warn(`[API] No token for request: ${config.method?.toUpperCase()} ${config.url}`);
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// ── Response interceptor — handle errors globally ─────────────────────────────
api.interceptors.response.use(
    (response) => response.data, // unwrap .data from every response
    (error) => {
        const status = error.response?.status;
        const url = error.config?.url || "";

        if (status === 401) {
            const isPinRoute =
                url.includes("/pin") ||
                url.includes("/unpin") ||
                url.includes("/pinned-messages");

            if (isPinRoute) {
                // Don't log out for pin routes — just log clearly
                console.error(
                    `[API] 401 on pin route: ${url}\n` +
                    `Token sent: ${error.config?.headers?.Authorization}\n` +
                    `Cookie present: ${document.cookie.includes("auth_token")}`
                );
            } else {
                // For other routes, warn but don't force logout in dev
                console.warn("[API] 401 Unauthorized on:", url);
            }
        }

        return Promise.reject(error);
    }
);

export default api;